/* @flow weak */
import { apiGet, apiPost } from '../lib/api'

export const APP_SET_LOCATION = 'APP_SET_LOCATION'
export const APP_START = 'APP_START'
export const APP_STORAGE_LOAD = 'APP_STORAGE_LOAD'
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS'
export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION'
export const SET_SCROLL_LOCATION = 'SET_SCROLL_LOCATION'

export const setLocation = (location) => ({
  type: APP_SET_LOCATION,
  payload: { location },
})

export const setScrollLocation = (location) => ({
  type: SET_SCROLL_LOCATION,
  payload: { location },
})

export const start = () => {
  const loadStorage = async (dispatch, storageEngine) => {
    const state = await storageEngine.load()
    dispatch({ type: APP_STORAGE_LOAD, payload: state })
  }
  return ({ dispatch, storageEngine }) => {
    loadStorage(dispatch, storageEngine).finally(() => {})
    return {
      type: APP_START,
    }
  }
}

export const fetchSettings = () => ({ getState, fetch }) => ({
  type: 'FETCH_SETTINGS',
  payload: apiGet({
    fetch,
    endpoint: 'settings',
    getState,
  }),
})

export const toggleNavigation = () => ({
  type: TOGGLE_NAVIGATION,
})



// WEBPACK FOOTER //
// ./src/common/app/actions.js